import React from "react";

const MultiplePara = ({ data }: { data: string[] }) => {
  if (!Array.isArray(data)) return null;
  return data.map((para, index) => (
    <p
      className={`${index === 0 ? "" : "lg:mt-1.5 md:mt-1.5"}`}
      key={index}
      dangerouslySetInnerHTML={{ __html: para }}
    />
  ));
};

export default MultiplePara;
